module.exports = __webpack_public_path__ + "static/media/banner1.561aca07.jpg";